import React, { Component } from 'react';
import Aux from '../../../hoc/Aux';
import axios from '../../../axios-ns';

import { Link } from 'react-router-dom'
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import * as messages from '../../../messages';

const styles = {
    card: {
        maxWidth: 345,
    },
    media: {
        height: 140,
    },
};


class Transactions extends Component {
    state = {
        transactions: []
    }

    componentDidMount() {
        if (localStorage.getItem('token')) {
            axios.get('protected/transactions/my', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    this.setState({ transactions: response.data });
                }).catch(err => {
                    console.log("error: " + err.response.data);
                })
        }
    }

    render() {
        let content = null;
        let startButton = null;
        let upgradeButton = null;

        if (this.state.transactions) {
            content = this.state.transactions.map(t => {

                if (t.status === 'PENDING_PAYMENT') {
                    startButton = <p style={{ color: '#f50057' }}>{messages.PENDING_PAYMENT}</p>
                } else {
                    startButton = <Button variant="outlined" color="primary" type="button" component={Link} to={'/protected/training/' + t.transactionCode}>
                        {messages.START_TRAINING}
                    </Button>
                }

                if (t.upgradesAvailable) {
                    upgradeButton = <Button variant="outlined" color="primary" type="button" component={Link} to={'/protected/training/' + t.productCode + '/upgrades'}>
                        {messages.SHOW_UPGRADES}
                    </Button>
                }

                return <Card key={t.name} style={{padding: '10px', margin: '5px', width: '100%'}}>
                        <h3>{t.name}</h3>
                        <h5>({t.transactionCode})</h5>
                        <p>Data utworzenia: <b>{t.createDate}</b></p>
                        <p>Cena: <b>{t.price} zł</b></p>
                        <p>Status: <b>{messages[t.status]}</b></p>
                </Card>
            }
            );
        }

        return <Aux>
            {content}
        </Aux>;
    }
}


export default Transactions; 